// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"af7395e7","453":"51ad56f0","455":"d140ad12","977":"d8e47832"}[chunkId] + ".chunk.js";
};